import { ActionTree, Commit } from 'vuex';
import { IState } from './state';
import config from '@/params/config';
import * as TYPES from './types';
import { apiFetchAction, apiFetchData } from '../apiUtil';

// const apiRoot: string = `${config.neo}/${config.apiVersion}`;
const apiRoot: string = config.neo;

interface IActionContent {
  state: IState;
  commit: Commit;
}

// 获取目录树
const getBoardMenu = async (content: IActionContent, payload: any) => {
  apiFetchAction(
    content.commit,
    'Report/GetReportList',
    'GET',
    TYPES.GET_BOARD_MENU,
    payload,
    false,
    apiRoot
  );
};

const getAccessUsers = async (content: IActionContent, payload: any) => {
  apiFetchAction(
    content.commit,
    'Report/GetAccessUsers',
    'POST',
    TYPES.GET_BOARD_ACCESS_USER,
    payload,
    false,
    apiRoot
  );
};

const setAccessUsers = async (content: IActionContent, payload: any) => {
  apiFetchAction(
    content.commit,
    'Report/SetAccessUsers',
    'POST',
    TYPES.SET_BOARD_ACCESS_USER,
    payload,
    false,
    apiRoot
  );
};

// 获取搜索热词
const getAdminUsers = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Admin/GetAllAdminUser',
    'GET',
    TYPES.ADMIN_USERS,
    payload,
    false,
    apiRoot
  );
};

const setAdminUsers = async (content: IActionContent, payload: any) => {
  apiFetchAction(
    content.commit,
    'Admin/UpdateAdminUser',
    'POST',
    TYPES.SET_BOARD_ACCESS_USER,
    payload,
    false,
    apiRoot
  );
};

// 查看运营看板权限
const hasReportAccess = async (content: IActionContent, payload: any) => {
  apiFetchAction(
    content.commit,
    'Report/HasReportAccess',
    'GET',
    TYPES.HAS_BOARD_HEAD_ACCESS,
    payload,
    false,
    apiRoot
  );
};

// 获取搜索热词
const getDocProducts = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Admin/GetAllDocProduct',
    'GET',
    TYPES.GET_ProductDoc_list,
    payload,
    false,
    apiRoot
  );
};

// 获取搜索热词
const getDocProductById = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Admin/GetDocProductById',
    'POST',
    TYPES.GET_ProductDoc_ById,
    payload,
    false,
    apiRoot
  );
};

// 获取业务文档的根目录
const getBusinessDocType = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Admin/GetBusinessDocType',
    'GET',
    TYPES.GET_Business_Doc_Types,
    payload,
    false,
    apiRoot
  );
};

// 获取业务文档的根目录
const getGitRemoteBranchName = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Admin/GetGitRemoteBranchName',
    'GET',
    TYPES.GET_Business_Git_Branchs,
    payload,
    false,
    apiRoot
  );
};

const saveDocProduct = async (content: IActionContent, payload: any) => {
  await apiFetchAction(
    content.commit,
    'Admin/SaveDocProduct',
    'POST',
    TYPES.SET_FORM_DATA,
    payload,
    false,
    apiRoot
  );
};

const syncDocFiles = async (content: IActionContent, payload: any) => {
  await apiFetchAction(
    content.commit,
    'Admin/SyncDocFiles',
    'POST',
    TYPES.SET_FORM_DATA,
    payload,
    false,
    apiRoot
  );
};

const deleteDocProduct = async (content: IActionContent, payload: any) => {
  await apiFetchAction(
    content.commit,
    'Admin/DeleteDocProduct',
    'DELETE',
    TYPES.SET_FORM_DATA,
    payload,
    false,
    apiRoot
  );
};

const getAllProductEvn = async (content: IActionContent, payload: object) => {
  await apiFetchAction(
    content.commit,
    'Admin/GetAllProductEvn',
    'GET',
    TYPES.GET_ProductEvn_list,
    payload,
    false,
    apiRoot
  );
};

const saveProductEvn = async (content: IActionContent, payload: any) => {
  await apiFetchAction(
    content.commit,
    'Admin/SaveProductEvn',
    'POST',
    TYPES.SET_FORM_DATA,
    payload,
    false,
    apiRoot
  );
};

const deleteProductEvn = async (content: IActionContent, payload: any) => {
  await apiFetchAction(
    content.commit,
    'Admin/DeleteProductEvn',
    'DELETE',
    TYPES.SET_FORM_DATA,
    payload,
    false,
    apiRoot
  );
};

export const actions = {
  getBoardMenu,
  getAccessUsers,
  setAccessUsers,
  hasReportAccess,
  getAdminUsers,
  setAdminUsers,
  getDocProducts,
  getDocProductById,
  saveDocProduct,
  syncDocFiles,
  deleteDocProduct,
  getBusinessDocType,
  getGitRemoteBranchName,
  getAllProductEvn,
  saveProductEvn,
  deleteProductEvn
};
